var React = require('react');

function Wifi (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M2.89 7.776c2.78-2.78 7.286-2.78 10.07 0l.706-.707c-3.173-3.174-8.313-3.17-11.482 0l.707.705z","fillRule":"nonzero","key":0}),React.createElement("path",{"d":"M15.82 5.152C11.46.792 4.39.79.027 5.152l.707.708c3.974-3.973 10.408-3.97 14.38 0l.706-.708zM5.045 9.692c1.59-1.59 4.168-1.59 5.758 0l.707-.707c-1.98-1.98-5.19-1.98-7.172 0l.707.707z","fillRule":"nonzero","key":1}),React.createElement("path",{"d":"M9.448 12.333c0 .84-.683 1.524-1.524 1.524-.84 0-1.524-.683-1.524-1.524 0-.84.683-1.523 1.524-1.523.84 0 1.524.682 1.524 1.523z","key":2})]));
}

Wifi.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Wifi;

Wifi.default = Wifi;
